"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndustryTypes;
(function (IndustryTypes) {
    IndustryTypes["Adult"] = "adult";
    IndustryTypes["Automotive"] = "automotive";
    IndustryTypes["Showcase"] = "showcase";
    IndustryTypes["BankInsurances"] = "bank_insurances";
    IndustryTypes["ConsumerEquipment"] = "consumer_equipment";
    IndustryTypes["Cosmetics"] = "cosmetics";
    IndustryTypes["Education"] = "education";
    IndustryTypes["Energy"] = "energy";
    IndustryTypes["Entertainment"] = "entertainment";
    IndustryTypes["Fashion"] = "fashion";
    IndustryTypes["FoodSupplies"] = "food_supplies";
    IndustryTypes["HealthSupplies"] = "health_supplies";
    IndustryTypes["Industrial"] = "industrial";
    IndustryTypes["Luxury"] = "luxury";
    IndustryTypes["Media"] = "media";
    IndustryTypes["NonProfitable"] = "non_profitable";
    IndustryTypes["RealEstate"] = "real_estate";
    IndustryTypes["Saas"] = "saas";
    IndustryTypes["ServiceToThePerson"] = "service_to_the_person";
    IndustryTypes["Telecom"] = "telecom";
    IndustryTypes["Travel"] = "travel";
})(IndustryTypes = exports.IndustryTypes || (exports.IndustryTypes = {}));
exports.ProjectIndustries = [
    {
        code: IndustryTypes.Adult,
        subcategories: [
            'accessories',
            'content',
        ],
    },
    {
        code: IndustryTypes.Automotive,
        subcategories: [
            'car_reseller',
            'corporate',
            'equipment',
            'rental',
        ],
    },
    {
        code: IndustryTypes.Showcase,
    },
    {
        code: IndustryTypes.BankInsurances,
        subcategories: [
            'banking',
            'credit_loans',
            'credit_card',
            'health_insurance',
            'no_health_insurance',
        ],
    }, {
        code: IndustryTypes.ConsumerEquipment,
        subcategories: [
            'home_furnishings_do_it_yourself_decore',
            'luggages',
            'office_supplies',
            'tech',
        ],
    }, {
        code: IndustryTypes.Cosmetics,
        subcategories: [
            'fragrance',
            'make_up',
            'skincare',
        ],
    }, {
        code: IndustryTypes.Education,
        subcategories: [
            'mooc',
            'school_website',
        ],
    }, {
        code: IndustryTypes.Energy,
    }, {
        code: IndustryTypes.Entertainment,
        subcategories: [
            'gambling',
            'gaming_site',
            'sport',
            'theater',
        ],
    }, {
        code: IndustryTypes.Fashion,
        subcategories: [
            'bags',
            'clothes_accessories',
            'eyewear',
            'footwear',
            'jewelry_watches',
            'sports_equipment_supplies',
            'underwear',
        ],
    }, {
        code: IndustryTypes.FoodSupplies,
        subcategories: [
            'restaurant',
            'supermarket',
            'wholesale_retail',
        ],
    }, {
        code: IndustryTypes.HealthSupplies,
        subcategories: [
            'optical',
            'pharmaceutical',
        ],
    }, {
        code: IndustryTypes.Industrial,
        subcategories: [
            'construction',
            'manufacturing',
            'supplies',
        ],
    }, {
        code: IndustryTypes.Luxury,
        subcategories: [
            'cars',
            'clothes',
            'home_furnishings',
            'jewelry',
            'leather_goods',
            'watches',
        ],
    }, {
        code: IndustryTypes.Media,
        subcategories: [
            'offline_streaming',
            'press',
            'social_media',
            'tv_live_streaming',
        ],
    }, {
        code: IndustryTypes.NonProfitable,
        subcategories: [
            'charity',
            'government',
        ],
    }, {
        code: IndustryTypes.RealEstate,
        subcategories: [
            'co_working',
            'commercial',
        ],
    }, {
        code: IndustryTypes.Saas,
        subcategories: [
            'analytics',
            'business_application',
            'collaborative',
            'content_builder',
            'stockage',
        ],
    }, {
        code: IndustryTypes.ServiceToThePerson,
    }, {
        code: IndustryTypes.Telecom,
        subcategories: [
            'brands',
            'provider',
            'telecommunication_facilities',
        ],
    }, {
        code: IndustryTypes.Travel,
        subcategories: [
            'blog_content',
            'hospitality',
            'transport',
            'trip_planning',
        ],
    },
];
exports.IndustryAudience = ['men', 'women', 'kids'];
//# sourceMappingURL=project.industry.js.map